<template>
  <v-card>
    <v-card-title class="primary">
      <span class="headline white--text">{{ $t('editingCustomLayersConnection') }}</span>
      <v-spacer/>
      <Icon
        iconColor="white"
        icon="mdi-close"
        :small="false"
        large
        :tooltipText="$t('close')"
        @icon-clicked="$emit('close')"
      />
    </v-card-title>
    <v-card-text>
      <FormWrapper
        strongValidation
        :disabled="saving"
        :buttonText="$t('save')"
        @submit="save">
        <v-container fluid>
          <v-row class="mt-2">
            <v-col cols="12">
              <v-text-field
                :label="$t('connectionString')"
                :type="hidden ? 'password' : 'text'"
                v-model="connectionString"
                :rules="[rules.required]"
                :hint="$t('customLayersConnectionHint')"
                persistent-hint
                autocomplete="off">
                <template #append-outer>
                  <Icon
                    :small="false"
                    :icon="hidden ? 'mdi-eye-off' : 'mdi-eye'"
                    icon-color="black"
                    @icon-clicked="hidden = !hidden"
                    :tooltipText="hidden ? $t('showConnectionString') : $t('hideConnectionString')"/>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </FormWrapper>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'
import fieldRules from '@/utils/rules'

export default {
  name: 'CustomLayersConnectionForm',

  components: {
    Icon: () => import('@/components/helper/Icon.vue'),
    FormWrapper: () => import('@/components/core/FormWrapper.vue')
  },

  data: () => ({
    rules: fieldRules.rules,
    connectionString: '',
    hidden: true,
    saving: false
  }),

  methods: {
    ...mapActions('user', ['updateCustomLayersConnection']),
    ...mapActions('snackbar', ['setSnack']),

    async save () {
      this.saving = true
      try {
        await this.updateCustomLayersConnection(this.connectionString.trim())
        this.setSnack(this.$t('customLayersConnectionSaved'))
        this.$emit('done-editing')
      } finally {
        this.saving = false
      }
    }
  }
}
</script>
